import * as React from "react";
const CircleSmallFilledSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: "9", cy: "9", r: "2" }));
CircleSmallFilledSmall.displayName = "CircleSmallFilledSmall";
var CircleSmallFilledSmall_default = CircleSmallFilledSmall;
export {
  CircleSmallFilledSmall_default as default
};
